'use client';

import Link from 'next/link';
import React from 'react';
import NextImage from 'src/components/_common/NextImage';

const HeaderLogo: React.FC = () => {
  return (
    <Link href="/" className="block px-2 py-[1px] pb-[2.4px]">
      <NextImage src="/images/common/logo_new.svg" width={87} height={17} alt="KottonSeed" />
    </Link>
  );
};

export default HeaderLogo;
